import React, { useState } from "react";
import styled from "styled-components";
import { FiChevronDown } from "react-icons/fi";
import { motion } from "framer-motion";

import emailjs from "emailjs-com";
import SuccessModal from "./SuccessModal";

export const sendEmail = (e) => {
  e.preventDefault();

  emailjs
    .sendForm(
      "service_p7zwf9g",
      "template_91kayfn",
      e.target,
      "LH1T0k5gxdDcTz8a5",
    )
    .then(
      (result) => {
        console.log("Email sent:", result.text);
      },
      (error) => {
        console.log("Error:", error.text);
      },
    );

  e.target.reset();
};

const Form = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    subject: "",
    language: "",
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleFormSubmission = (event) => {
    event.preventDefault();
    sendEmail(event);
    setIsModalOpen(true);
    setFormData({
      name: "",
      email: "",
      mobile: "",
      subject: "",
      language: "",
    });
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 50 }} // Start hidden + slightly below
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }} // Smooth timing
      >
        <FormWrapper>
          <Header>
            <h6>Contact Us</h6>
            <h1>
              Get <span>Connected</span> In Minutes!
            </h1>
            <p>
              Fill in your details and our financial experts will get in touch
              with you shortly.
            </p>
          </Header>

          <StyledForm onSubmit={handleFormSubmission}>
            <FormContent>
              <FormGroup>
                <InputWrapper>
                  <StyledInput
                    type="text"
                    id="name"
                    placeholder=" "
                    name="user_name"
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    value={formData.name}
                    required
                  />
                  <StyledLabel htmlFor="name">Name</StyledLabel>
                </InputWrapper>
              </FormGroup>

              <FormGroup>
                <InputWrapper>
                  <StyledInput
                    type="email"
                    id="email"
                    name="user_email"
                    placeholder=" "
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    value={formData.email}
                  />
                  <StyledLabel htmlFor="email">Email</StyledLabel>
                </InputWrapper>
              </FormGroup>

              <FormGroup>
                <InputWrapper>
                  <StyledInput
                    type="text"
                    id="mobile"
                    name="user_mobile"
                    placeholder=" "
                    required
                    onChange={(e) => {
                      setFormData({ ...formData, mobile: e.target.value });
                    }}
                    value={formData.mobile}
                  />
                  <StyledLabel htmlFor="mobile">Mobile</StyledLabel>
                </InputWrapper>
              </FormGroup>

              <FormGroup>
                <SelectWrapper>
                  <StyledSelect
                    id="subject"
                    name="subject"
                    onChange={(e) => {
                      setFormData({ ...formData, subject: e.target.value });
                    }}
                    value={formData.subject}
                    required
                  >
                    <option value="" disabled hidden>
                      Select Subject
                    </option>
                    <option value="general">General Inquiry</option>
                    <option value="general">Savings</option>
                    <option value="insurance">Insurance</option>
                    <option value="insurance">Tax Planning</option>
                    <option value="other">Other</option>
                  </StyledSelect>
                  <StyledLabel htmlFor="subject">Subject</StyledLabel>
                  <FiChevronDown className="chevron" />
                </SelectWrapper>
              </FormGroup>

              <FormGroup className="full-width">
                <SelectWrapper>
                  <StyledSelect
                    id="language"
                    name="language"
                    onChange={(e) => {
                      setFormData({ ...formData, language: e.target.value });
                    }}
                    value={formData.language}
                    required
                  >
                    <option value="" disabled hidden>
                      Select Language
                    </option>
                    <option value="kannada">Kannada</option>
                    <option value="english">English</option>
                    <option value="hindi">Hindi</option>
                    <option value="telugu">Telugu</option>
                    <option value="tamil">Tamil</option>
                    <option value="malayalam">Malayalam</option>
                  </StyledSelect>
                  <StyledLabel htmlFor="language">Language</StyledLabel>
                  <FiChevronDown className="chevron" />
                </SelectWrapper>
              </FormGroup>
              <input
                type="hidden"
                name="time"
                value={new Date().toLocaleString()} // Current date + time
              />
            </FormContent>
            <SubmitButton type="submit">Submit</SubmitButton>
          </StyledForm>
        </FormWrapper>
        {isModalOpen && <SuccessModal onClose={() => setIsModalOpen(false)} />}
      </motion.div>
    </>
  );
};

export default Form;

// ============== Styled Components ==============

const FormWrapper = styled.div`
  height: 100%;
  max-width: 700px;
  margin: 0 auto;
  padding: 20px 20px;
  /* background: #e9ecef; */
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.06);
  span {
    color: #fdc500;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;

  h6 {
    font-size: 14px;
    color: #005f73;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }

  h1 {
    font-size: 28px;
    margin-bottom: 10px;
    color: #222;
  }

  p {
    color: #555;
    font-size: 1.1rem;
    max-width: 500px;
    margin: 0 auto;
  }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 30px;

  @media (max-width: 768px) {
    gap: 20px;
  }
`;

const FormContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FormGroup = styled.div`
  position: relative;

  &.full-width {
    grid-column: 1 / -1;
  }
`;

const InputWrapper = styled.div`
  position: relative;
`;

const SelectWrapper = styled.div`
  position: relative;

  .chevron {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: #666;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 20px 14px 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: transparent;
  transition: border 0.3s;

  &:focus {
    border-color: #005f73;
    outline: none;
  }

  &:focus + label,
  &:not(:placeholder-shown) + label {
    top: 8px;
    left: 12px;
    font-size: 12px;
    color: #005f73;
    padding: 0 4px;
  }
`;

const StyledLabel = styled.label`
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  background: transparent;
  transition: 0.2s ease all;
  pointer-events: none;
`;

const StyledSelect = styled.select`
  width: 100%;
  padding: 20px 40px 8px 14px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: transparent;
  appearance: none;
  transition: border 0.3s;

  &:focus {
    border-color: #005f73;
    outline: none;
  }

  &:focus + label,
  &:not([value=""]) + label {
    top: 8px;
    left: 12px;
    font-size: 12px;
    color: #005f73;
    padding: 0 4px;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 16px 0;
  background: linear-gradient(135deg, #005f73, #00c389);
  color: #fff;
  font-size: 17px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition:
    background 0.3s,
    transform 0.2s;

  &:hover {
    background: linear-gradient(135deg, #005f73, #00c389);
    transform: translateY(-2px);
  }
`;
